import { trackedKeywordModel } from '@models/keyword/keywordModel';

export class KeywordTracking {
  private data: any[]; // 추후 데이터 받기
  constructor(data) {
    this.data = data;
  }

  // AnalyzeKeyword > keywordTracking >  Bpart > Tracked Keyword
  getBpartTrackedKeywords(): trackedKeywordModel[] {
    return this.data.map((item) => ({ ...item, colorpopup: false, notesPopup: false }));
  }
}
